<template>
  <Loader v-if="loading" />
  <div class="layout">
    <div class="layout-menu-container">
      <div class="logo-container">
        <img src="https://agfenergy.it/wp-content/uploads/2023/06/marchiologo.png" alt="Logo" class="logo"
          style="width: 100%; height: auto; margin-top: 10px; margin-bottom: 50px;" />
      </div>
      <ul class="layout-menu">
        <li class="layout-root-menuitem" :class="{ 'active-menuitem': activeMenu === 'residenza' }">
          <div class="layout-menuitem-root-text" :class="{ 'active': step >= 0 }">Informazioni Cliente</div>
          <ul class="layout-root-submenulist">
            <li>
              <a href="#" @click="activeMenu = 'residenza'" tabindex="0">
                <i class="pi pi-fw pi-map-marker layout-menuitem-icon"></i>
                <span class="layout-menuitem-text" :class="{ 'active': step >= 0 }">Indirizzo di Residenza</span>
              </a>
            </li>
          </ul>
          <div class="layout-menuitem-root-text" :class="{ 'active': step >= 1 }">ENERGIA ELETTRICA</div>
          <ul class="layout-root-submenulist">
            <li>
              <a href="" class="" tabindex="0">
                <i class="pi pi-briefcase layout-menuitem-icon"></i>
                <span class="layout-menuitem-text" :class="{ 'active': step >= 2 }">Dati Forniture</span>
              </a>
            </li>
            <li>
              <a href="" class="" tabindex="0">
                <i class="pi pi-percentage layout-menuitem-icon"></i>
                <span class="layout-menuitem-text" :class="{ 'active': step >= 3 }">IVA ed Aliquote</span>
              </a>
            </li>
          </ul>
          <div class="layout-menuitem-root-text" :class="{ 'active': step >= 4 }">PAGAMENTO</div>
          <ul class="layout-root-submenulist">
            <li>
              <a href="" class="" tabindex="0">
                <i class="pi pi-fw pi-dollar layout-menuitem-icon"></i>
                <span class="layout-menuitem-text" :class="{ 'active': step >= 4 }">Pagamento</span>
              </a>
            </li>
            <li>
              <a href="" class="" tabindex="0">
                <i class="pi pi-fw pi-check layout-menuitem-icon"></i>
                <span class="layout-menuitem-text" :class="{ 'active': step === 5 }">Accettazioni</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="layout-content-wrapper">
      <div class="layout-form-container">
        <div v-if="!submitted">
          <h2 class="form-title" style="text-align: left;">{{ title }}</h2>
          <div v-if="step == 0">
            <div class="form-row">
              <div class="form-group">
                <label for="name">Nome *</label>
                <!-- <input type="text" id="name" v-model="form.name" required /> -->
                <InputText id="name" v-model="form.name" @input="(val) => (form.name = form.name.toUpperCase())" />
              </div>
              <div class="form-group">
                <label for="cognome">Cognome *</label>
                <!-- <input type="text" id="cognome" v-model="form.cognome" required /> -->
                <InputText id="cognome" v-model="form.cognome"
                  @input="(val) => (form.cognome = form.cognome.toUpperCase())" />

              </div>
            </div>
            <div class="form-group">
              <label for="codicefiscale">Codice Fiscale *</label>
              <!-- <input type="text" id="codicefiscale" v-model="form.codicefiscale" required /> -->
              <!-- <InputText id="codicefiscale" v-model="form.codicefiscale" @input="(val) => (form.codicefiscale = form.codicefiscale.toUpperCase())"/> -->
              <InputMask mask="aaaaaa99a99a999a" id="codicefiscale" v-model="form.codicefiscale" autofocus class="text_toupper" :slotChar="''" placeholder="ABCDEF12G34H567I" @blur="onInputCodFis($event)"/>
            </div>

            <div class="form-group">
              <label for="file-upload">Carica Documento *</label>
              <small class="file-description">Tipi di file accettati: jpg, gif, png, pdf, heic. Dimensione max del file:
                256 MB.</small>
              <div class="file-upload-wrapper">
                <input type="file" id="file-upload" @change="handleFileUpload" required hidden />
                <button type="button" class="file-upload-button" @click="selectFile">Scegli file</button>
                <p class="file-name">{{ form.file ? form.file.name : 'Nessun file selezionato' }}</p>
              </div>
            </div>
            <div>
              * = Obbligatorio
            </div>
          </div>
          <div v-if="step == 1">
            <div class="form-row">
              <div class="form-group half-width">
                <label for="toponimo">Toponimo *</label>
                <InputText id="toponimo" v-model="form.toponimo" @input="(val) => (form.toponimo = form.toponimo.toUpperCase())" />
              </div>
              <div class="form-group half-width">
                <label for="indirizzo">Indirizzo *</label>
                <InputText id="indirizzo" v-model="form.indirizzo" @input="(val) => (form.indirizzo = form.indirizzo.toUpperCase())" />
              </div>
              <div class="form-group half-width">
                <label for="numerocivico">N. Civico *</label>
                <InputText id="numerocivico" v-model="form.numerocivico" @input="(val) => (form.numerocivico = form.numerocivico.toUpperCase())" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Provincia *</label>
                <Dropdown @change="onSelectedDistrict($event, 'legale')" v-model="form.provincia" :options="districts" optionLabel="name" :filter="true" optionValue="code" placeholder="Seleziona provincia" class="w-full"/>
              </div>
              <div class="form-group half-width">
                <label>Comune *</label>
                <Dropdown v-model="form.cod_comune" :options="cities" :filter="true" optionLabel="name" optionValue="id"
                  placeholder="Seleziona comune" class="w-full" />
              </div>
              <div class="form-group half-width">
                <label for="cap">CAP *</label>
                <input type="text" id="cap" v-model="form.cap" required />
              </div>
              <div class="form-group half-width">
                <label for="numero-telefonico">Telefono/Cellulare *</label>
                <input type="text" id="numero-telefonico" v-model="form.numerotelefonico" required />
              </div>
            </div>

            <div class="form-group full-width">
              <label>Email</label>
              <input type="email" id="email" v-model="form.email" required />
            </div>
            <div class="form-group full-width">
              <label>Conferma Email</label>
              <input type="email" id="conferma-email" v-model="form.emailConfirm" required />
            </div>
            <div>
              * = Obbligatorio
            </div>
          </div>
          <div v-if="step == 2">
            <div class="form-row">
              <div class="form-group">
                <label for="bolletta">Ultima Bolletta *</label>
                <div class="file-upload-area" @dragover.prevent @drop.prevent="handleFileDrop"
                  @click="selectFileBolletta">
                  <input type="file" id="file-upload-bolletta" @change="handleFileUploadBolletta" required hidden />
                  <div class="flex flex-column">
                    <p>(Trascina qui un file o fai clic per selezionare un file)</p>
                    <p class="file-name">{{ form.fileBolletta ? form.fileBolletta.name : 'Nessun file selezionato' }}</p>
                  </div>
                </div>
                <small class="file-description">Allegare prima e seconda pagina della bolletta.</small>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label for="datiFornitura">Dati di Fornitura</label>
                <div class="radio-group">
                  <RadioButton v-model="form.fornituraTipo" inputId="domesticoresidente" name="fornitura" value="1" />
                  <label for="domesticoresidente">Domestico Residente</label>
                </div>
                <div class="radio-group">
                  <RadioButton v-model="form.fornituraTipo" inputId="domesticononresidente" name="fornitura" value="2" />
                  <label for="domesticononresidente">Domestico non Residente</label>
                </div>
                <div class="radio-group">
                  <RadioButton v-model="form.fornituraTipo" inputId="usi" name="fornitura" value="3" />
                  <label for="usi">Altri Usi (Esempio Luci scale, Pozzo, Parti Comuni, ecc.)</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 xl:col-5" v-for="type_pp in type.split('&')" :key="type_pp">
                <label for="code">{{ type_pp == 'ee' ? 'POD' : 'PDR' }} *</label>
                <InputText id="code" v-model="form[`code_${type_pp}`]" @input="(val) => (form[`code_${type_pp}`] = form[`code_${type_pp}`].toUpperCase())" />
              </div>
            </div>
            <div>
              * = Obbligatorio
            </div>
          </div>
          <div v-if="step == 3">
            <h4>Imposta sul valore aggiunto - aliquota </h4>

            <div class="form-row">
              <div class="form-group half-width">
                <div>
                  Aliquota {{ form.fornituraTipo == '1' ? 'ordinaria per uso domestico 10%' : '22%' }}
                </div>
              </div>
            </div>

            <h4>Eventuali acquisti in sospensione d’imposta</h4>
            <small>Barrare le caselle solo se soggetti a sospensione d’imposta.</small>
            <br>
            <div class="form-row">
              <div class="form-group half-width">
                <div class="radio-group">
                  <RadioButton v-model="form.sospensione" inputId="acquisti-sospensione" name="sospensione"
                    value="sospensione" />
                  <label for="acquisti-sospensione">Acquisti in sospensione d’imposta (c.d. esportatori abituali), ai
                    sensi dell’art. 8 comma 1, lett. C.D.P.R. 633/72 e s.m.i.</label>
                </div>
              </div>
            </div>
          </div>

          <div v-if="step == 4">
            <!-- <div class="form-row">
              <div class="form-group" style="margin-right: 20px;">
                <label for="email">Email</label>
                <input type="email" id="email" v-model="form.email" required />
              </div>

              <div class="form-group half-width">
                <label>Frequenza di fatturazione desiderata</label>
                <div class="radio-group">
                  <RadioButton inputId="mensile" name="frequenza" v-model="form.frequenza" value="mensile" />
                  <label for="mensile">Mensile</label>
                </div>
                <div class="radio-group">
                  <RadioButton inputId="bimestrale" name="frequenza" v-model="form.frequenza" value="bimestrale" />
                  <label for="bimestrale">Bimestrale</label>
                </div>
              </div>
            </div> -->

            <div class="form-row">
              <div class="form-group" style="margin-right: 20px;">
                <label>Metodo di Pagamento *</label>
                <Dropdown v-model="form.pagamento" :options="opzionipagamento" optionLabel="name" optionValue="id"
                  placeholder="Scegli modalità di pagamento" class="w-full" />
              </div>


            </div>

            <div class="form-row" v-if="form.pagamento && form.pagamento == 1">
              <div class="form-group">
                <label for="iban">Coordinare del Conto - Codice IBAN</label>
                <input type="text" id="iban" v-model="form.iban" required />
              </div>
            </div>
            <div>
              * = Obbligatorio
            </div>
          </div>
          <div v-if="step == 5">
            <p>Io sottoscritto dichiaro espressamente di aver ricevuto l’informativa di cui all’art.13 D.lgs. 193/03 e
              del
              Regolamento UE 679/16 e di autorizzare il titolare del trattamento all’utilizzo dei miei dati per le
              finalità di seguito indicate:</p>

            <div class="form-row">
              <div class="form-group half-width">
                <label>Grado di soddisfazione della clientela:</label>
                <div class="radio-group">
                  <RadioButton inputId="soddisfazione-si" name="soddisfazione-clientela"
                    v-model="form.soddisfazioneClientela" value="si" />
                  <label for="soddisfazione-si">SI</label>
                </div>
                <div class="radio-group">
                  <RadioButton inputId="soddisfazione-no" name="soddisfazione-clientela"
                    v-model="form.soddisfazioneClientela" value="no" />
                  <label for="soddisfazione-no">NO</label>
                </div>
              </div>

              <div class="form-group half-width">
                <label>Attività promozionali:</label>
                <div class="radio-group">
                  <RadioButton inputId="attivita-promozionali-si" name="attivita-promozionali"
                    v-model="form.attivitaPromozionali" value="si" />
                  <label for="attivita-promozionali-si">SI</label>
                </div>
                <div class="radio-group">
                  <RadioButton inputId="attivita-promozionali-no" name="attivita-promozionali"
                    v-model="form.attivitaPromozionali" value="no" />
                  <label for="attivita-promozionali-no">NO</label>
                </div>
              </div>

              <div class="form-group half-width">
                <label>Attività di Marketing:</label>
                <div class="radio-group">
                  <RadioButton inputId="marketing-si" name="attivita-marketing" v-model="form.attivitaMarketing"
                    value="si" />
                  <label for="marketing-si">SI</label>
                </div>
                <div class="radio-group">
                  <RadioButton inputId="marketing-no" name="attivita-marketing" v-model="form.attivitaMarketing"
                    value="no" />
                  <label for="marketing-no">NO</label>
                </div>
              </div>
            </div>

            <p>Autorizzo altresì il trattamento dei miei dati da parte dei soggetti terzi per finalità di seguito
              elencate:</p>

            <div class="form-row">
              <div class="form-group half-width">
                <label>Grado di soddisfazione della clientela:</label>
                <div class="radio-group">
                  <RadioButton inputId="soddisfazione-seconda-si" name="soddisfazione-seconda"
                    v-model="form.soddisfazioneSeconda" value="si" />
                  <label for="soddisfazione-seconda-si">SI</label>
                </div>
                <div class="radio-group">
                  <RadioButton inputId="soddisfazione-seconda-no" name="soddisfazione-seconda"
                    v-model="form.soddisfazioneSeconda" value="no" />
                  <label for="soddisfazione-seconda-no">NO</label>
                </div>
              </div>

              <div class="form-group half-width">
                <label>Attività promozionali:</label>
                <div class="radio-group">
                  <RadioButton inputId="attivita-promozionali-seconda-si" name="attivita-promozionali-seconda"
                    v-model="form.attivitaPromozionaliSeconda" value="si" />
                  <label for="attivita-promozionali-seconda-si">SI</label>
                </div>
                <div class="radio-group">
                  <RadioButton inputId="attivita-promozionali-seconda-no" name="attivita-promozionali-seconda"
                    v-model="form.attivitaPromozionaliSeconda" value="no" />
                  <label for="attivita-promozionali-seconda-no">NO</label>
                </div>
              </div>
              <div class="form-group half-width">
                <label>Attività di Marketing:</label>
                <div class="radio-group">
                  <RadioButton inputId="marketing-seconda-si" name="attivita-marketing-seconda"
                    v-model="form.attivitaMarketingSeconda" value="si" />
                  <label for="marketing-seconda-si">SI</label>
                </div>
                <div class="radio-group">
                  <RadioButton inputId="marketing-seconda-no" name="attivita-marketing-seconda"
                    v-model="form.attivitaMarketingSeconda" value="no" />
                  <label for="marketing-seconda-no">NO</label>
                </div>
              </div>
            </div>
            <label>Esecuzione
              *
            </label>
            <div class="form-row">
              <div class="radio-group">
                <RadioButton inputId="esecuzione-anticipata" name="esecuzione-anticipata"
                  v-model="form.EsecuzioneAnticipata" value="si" />
                <label for="esecuzione-anticipata">Con la firma della presente proposta contrattuale richiedo
                  l'esecuzione
                  anticipata del contratto e, pertanto, le operazioni per l’attivazione della fornitura potranno essere
                  avviate da AGF ENERGY SpA prima che sia decorso il termine per l’esercizio del diritto di ripensamento
                  (14 giorni dalla conclusione del Contratto)</label>
              </div>
            </div>
            <p>Il cliente con sottoscrizione del presente modulo, formula la proposta di contratto a AGF ENERGY
              contestualmente dichiara di aver ricevuto e preso visione (e di accettare i contenuti) dei seguenti
              allegati: Condizioni Tecnico Economiche, Livelli di qualità commerciale, Condizioni Generali di Fornitura
              (comprensive di Informativa sul trattamento dei dati personali), Modello di comunicazione dati catastali,
              Scheda sintetica e Scheda di confrontabilità dell’offerta (quest’ultima per i soli clienti domestici). Il
              cliente dichiara: Di recedere irrevocabilmente dai contratti di fornitura di gas e/o energia elettrica in
              essere con i fornitori ivi indicati, incaricando AGF ENERGY darne comunicazione a quest’ultimi e che, a
              partire dalla data di efficacia del predetto recesso sarà rifornito da AGF ENERGY Di dare specifico
              mandato con rappresentanza ad AGF ENERGY affinché formalizzi ai fornitori uscenti di gas e/o energia
              elettrica i suddetti recessi ed effettui la somministrazione da parte di AGF ENERGY con
              l’intervenuta efficacia dei recessi esercitati eventualmente presso i precedenti fornitori, nel rispetto
              dei
              tempi previsti dalla normativa vigente Del. AEEG n°144/07 e s.m.i Ai sensi e per gli effetti degli artt.
              1341 e 1342 cod. civ., il Cliente dichiara di approvare specificatamente i seguenti articoli delle
              Condizioni Generali di Fornitura: 2 - Oggetto del contratto; 3 – Conclusione e consegna del Contratto o
              della conferma del Contratto, perfezionamento del Contratto; 4 - Durata e decorrenza del Contratto,
              diritto
              di recesso e diritto di ripensamento; 6 - Cessione del contratto; 7 - Condizioni di fornitura; 9 –
              Responsabilità; 13 - Modalità di fatturazione e pagamento; 14 - Ritardo nei pagamenti; 15 – Garanzie; 16 -
              Cessione dei crediti; 17 - Clausola risolutiva espressa; 18 - Forza maggiore.</p>
            <label>Accettazioni *
            </label>
            <div class="form-row">
              <div class="radio-group">
                <RadioButton inputId="accettazione" name="accettazione" v-model="form.Accettazione" value="si" />
                <label for="accettazione">
                  Ho letto e accettato le condizioni di fornitura.</label>
              </div>
              <div class="radio-group">
                <RadioButton inputId="accettazionec" name="accettazionec" v-model="form.Accettazionec" value="si" />
                <label for="accettazionec">
                  Ho letto e accettato le Condizioni Tecnico Economiche (CTE).</label>
              </div>

            </div>

            
            <div v-if="tesserino.includes(name_logo)">
              <label><strong>NUMERO TESSERINO CISL *</strong></label>
              <InputText v-model="form.tesserino"/>            
            </div>
            <div>
              * = Obbligatorio
            </div>
          </div>
          <div class="form-group button-group">
            <Button icon="pi pi-arrow-left" label="Indietro" @click="prevstep" style="margin-right: 10px;" class="submit-button" v-if="step > 0" />
            <Button label="Avanti" icon="pi pi-arrow-right" @click="nextstep" class="submit-button"/>
          </div>

        </div>
        <div v-else>
          <div class="dialog-content"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 20px;">
            <i class="pi pi-check-circle animated-icon" style="font-size: 4rem; color: green;"></i>

            <span class="text-surface-500 dark:text-surface-400 mt-3 font-semibold" style="font-size: 3rem">
              Grazie per aver compilato il form!
            </span>

            <span class="text-surface-500 dark:text-surface-400 mt-4" style="font-size: 1.5rem">
              Riceverai un'email di conferma con le istruzioni per convalidare la firma del contratto, nelle prossime
              due ore.
            </span>


            <span class="text-surface-500 dark:text-surface-400 mt-4" style="font-size: 1rem">
              In caso di mancata ricezione dell'email, contattare il backoffice di AGF ENERGY SpA alla mail
              backoffice@agfenergy.it
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
// @ is an alias to /src
// eslint-disable-next-line no-unused-vars
import { FilterMatchMode } from 'primevue/api';
import moment from 'moment'
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useRoute, useRouter } from 'vue-router';
import Loader from "@/components/Loader.vue"
import { useToast } from "primevue/usetoast";


export default {
  components: {
    Loader
  },
  setup(props, { emit }) {
    const toast = useToast()
    const loading = ref(false)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const submitted = ref(false)
    const route = useRoute()
    const router = useRouter()
    const params = route.params
    const token = ref()
    const type = ref()
    const tipo = ref()
    const requiredDocuments = ref(['file', 'fileBolletta'])
    const name_logo = ref('')
    const form = ref({
      name: '',
      cognome: '',
      codicefiscale: '',
      email: '',
      code_ee: '',
      code_gas: '',
      iban: '',
      file: null,
      indirizzo: '',
      numerocivico: '',
      provincia: '',
      cap: '',
      numerotelefonico: '',
      emailConfirm: '',
      fileBolletta: null,
      aliquota: '',
      fornituraTipo: '1',
      pagamento: null,
      soddisfazioneClientela: 'si',
      attivitaPromozionali: 'si',
      attivitaMarketing: 'si',
      soddisfazioneSeconda: 'si',
      attivitaPromozionaliSeconda: 'si',
      attivitaMarketingSeconda: 'si',
      EsecuzioneAnticipata: 'si',
      Accettazione: 'si',
      Accettazionec: 'si',
      frequenza: 'mensile'
    });
    
    const districts = ref([])
    const cities = ref([])
    const tesserino = ref(['fnp'])

    const step = ref(0);
    const title = ref("Benvenuto");
    const activeMenu = ref('residenza');
    const opzionipagamento = ref([
      { id: 1, name: 'Addebito su conto corrente - RID', code: 'CC' },
      { id: 2, name: 'Bollettino Postale', code: 'BP' },
    ]);

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        form.value.file = file;
      }
    };

    const handleFileDrop = (event) => {
      const file = event.dataTransfer.files[0];
      if (file) {
        form.value.file = file;
      }
    };
    const handleFileUploadBolletta = (event) => {
      const file = event.target.files[0];
      if (file) {
        form.value.fileBolletta = file;
      }
    };
    const selectFileBolletta = () => {
      document.getElementById('file-upload-bolletta').click();
    };
    const selectFile = () => {
      document.getElementById('file-upload').click();
    };

    const nextstep = () => {
      if (step.value == 5) {
        handleSubmit()
      } else {
        if (!validateStep()) {
          // alert('Compila tutti i campi');
          return;
        }
  
        step.value++;
        if (step.value === 0) {
          title.value = "Benvenuto";
          activeMenu.value = 'residenza';
        } else if (step.value === 1) {
          title.value = "Indirizzo di Residenza";
          activeMenu.value = 'indirizzo-residenza';
        } else if (step.value === 2) {
          title.value = "Dati Forniture";
          activeMenu.value = 'dati-forniture';
        } else if (step.value === 3) {
          title.value = "Energia Elettrica - IVA ed Aliquote";
          activeMenu.value = 'iva-aliquote';
        } else if (step.value === 4) {
          title.value = "Pagamento";
          activeMenu.value = 'fatturazione-pagamento';
        } else if (step.value === 5) {
          title.value = "Accettazioni";
          activeMenu.value = 'accettazioni';
        }
      }
    };
    const prevstep = () => {
      step.value--;
      if (step.value === 0) {
        title.value = "Benvenuto";
        activeMenu.value = 'residenza';
      } else if (step.value === 1) {
        title.value = "Indirizzo di Residenza";
        activeMenu.value = 'indirizzo-residenza';
      } else if (step.value === 2) {
        title.value = "Dati Forniture";
        activeMenu.value = 'dati-forniture';
      } else if (step.value === 3) {
        title.value = "Energia Elettrica - IVA ed Aliquote";
        activeMenu.value = 'iva-aliquote';
      } else if (step.value === 4) {
        title.value = "Pagamento";
        activeMenu.value = 'fatturazione-pagamento';
      } else if (step.value === 5) {
        title.value = "Accettazioni";
        activeMenu.value = 'accettazioni';
      }
    };
    const validateStep = () => {
      if (step.value === 0) {
        if (!form.value.name || !form.value.cognome || !form.value.codicefiscale || !form.value.file) {
          // toast.add({severity:'warn', summary:'Attenzione', detail: `Compila tutti i campi obbligatori`});
          alert('Compila tutti i campi');
          return false;
        }
        if (!isValidCodiceFiscale(form.value.codicefiscale)) {
          alert('Il Codice Fiscale inserito non è valido.');
          return false;
        }
        return true;
      } else if (step.value === 1) {
        // Validazione per la seconda pagina: Indirizzo di Residenza
        if (!form.value.indirizzo || !form.value.numerocivico || !form.value.provincia ||
          !form.value.cap || !form.value.numerotelefonico || !form.value.email || !form.value.emailConfirm) {
          alert('Compila tutti i campi richiesti nella pagina 2.');
          return false;
        }
        if (!isValidNumeroCivico(form.value.numerocivico)) {
          alert('Il numero civico deve avere massimo 5 numeri.');
          return false;
        }
        if (!isValidProvincia(form.value.provincia)) {
          alert('La provincia deve essere composta da 2 lettere.');
          return false;
        }
        if (!isValidCAP(form.value.cap)) {
          alert('Il CAP deve essere composto da 5 numeri.');
          return false;
        }
        if (!isValidTelefono(form.value.numerotelefonico)) {
          alert('Il numero di telefono deve contenere solo numeri.');
          return false;
        }
        if (!isValidEmail(form.value.email)) {
          alert('Inserisci un\'email valida.');
          return false;
        }
        // Controllo se le email corrispondono
        if (form.value.email !== form.value.emailConfirm) {
          alert('Le email inserite non corrispondono.');
          return false;
        }
      } else if (step.value === 2) {
        let valid_ee = true
        let valid_gas = true
        type.value.split('&').forEach(type_pp => {          
          let device = type_pp == 'ee' ? 'POD' : 'PDR'
          let method = `isValid${device}`
          console.log(eval(method)(form.value[`code_${type_pp}`]));
          
          if (!eval(method)(form.value[`code_${type_pp}`])) {
            type_pp == 'ee' ? valid_ee = false : valid_gas = false
            alert(`Inserire ${device} Corretto`)
          } 
        })
        if (!valid_ee || !valid_gas ) {
          return false
        }
        if (!form.value.fornituraTipo) {
          alert('Seleziona un tipo di fornitura');
          return false;
        }
        return true;
      } else if (step.value === 4) {
        if (!form.value.pagamento) {
          alert('Seleziona un tipo di pagamento.');
          return false;
        } else {
          if (form.value.pagamento.code == 1 && !isValidIBAN(form.value.iban)) {
            alert('Il codice IBAN deve essere esattamente 27 caratteri e seguire il formato corretto.');
            return false;
          }
        }
      } else if (step.value === 5) {        
        if (tesserino.value.includes(name_logo.value)) {
          if (!form.value.tesserino) {
            alert('Inserisci il numero di tesserino CISL.');
            return false;
          }
        }
      }

      return true; // If all validations pass
    };

    // VALIDAZIONI
    const isValidCodiceFiscale = (cf) => {
      const regex = /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/;
      return regex.test(cf);
    };
    const isValidNumeroCivico = (numeroCivico) => {
      // return /^[0-9]{1,4}$/.test(numeroCivico);
      return numeroCivico != '' && numeroCivico != null
    };

    const isValidProvincia = (provincia) => {
      return /^[A-Z]{2}$/.test(provincia);
    };

    const isValidCAP = (cap) => {
      return /^[0-9]{5}$/.test(cap);
    };

    const isValidTelefono = (telefono) => {
      return /^[0-9]+$/.test(telefono);
    };

    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    const isValidPOD = (code) => {
      const regex = /^IT[0-9]{3}E[0-9]{7}[0-9A]$/;
      return regex.test(code);
    };
    const isValidPDR = (code) => {
      const regex = /[0-9]{14}/;
      return regex.test(code);
    };
    const isValidIBAN = (iban) => {
      const regex = /^(IT\d{2}[A-Z]\d{10}[0-9A-Z]{12})$/;
      return regex.test(iban);
    };
    const handleSubmit = async () => {
      if (validateStep()) {
        form.value.fornituraTipo = Number(form.value.fornituraTipo)
        form.value.token = token.value
        form.value.type = type.value
        form.value.tipo = tipo.value
        let fd = new FormData()
        requiredDocuments.value.forEach((doc) => {
          fd.append(`${doc}[]`, form.value[doc]);
        })
  
        Object.keys(form.value).forEach((key) => {
          if (!['file', 'fileBolletta'].includes(key)) {
            fd.append(`${key}`, JSON.stringify(form.value[key]));
          }
        })
        let comune = cities.value.find(city => city.id == form.value.cod_comune)
        fd.append('nome_comune', JSON.stringify(comune.name.toUpperCase()));
        loading.value = true
        await service.sendFormLanding(fd)
          .then((res) => {
            submitted.value = true
          })
          .finally(() => {
            loading.value = false
          })
      }
    };
    const onSelectedDistrict = (evt) => {
      service.getCities(evt.value).then((res) => {
        cities.value = res.items
      })
    }

    const getDistricts = () => {
      service.getDistricts().then((res) => {
        districts.value = res.items
      })
    }
    const onInputCodFis = (e) => {      
      form.value.codicefiscale = e.target.value.toUpperCase()      
    }
    onMounted(() => {
      name_logo.value = route.meta[0].name_logo
      
      getDistricts()
      token.value = params.token
      type.value = params.type
      tipo.value = params.tipo
      if (!token.value) {
        router.push('/unauthorized')
      } else if (!type.value) {
        router.push('landing/' + token.value)
      }
    })

    return {
      nextstep,
      prevstep,
      step,
      form,
      title,
      activeMenu,
      handleFileUpload,
      handleFileUploadBolletta,
      handleFileDrop,
      selectFileBolletta,
      selectFile,
      validateStep,
      opzionipagamento,
      handleSubmit,
      // resetForm,
      districts,
      onSelectedDistrict,
      cities,
      type,
      submitted,
      loading,
      tesserino,
      name_logo,
      onInputCodFis,
    };
  }
}
</script>
<style scoped>
.text_toupper {
  text-transform: uppercase !important;
}

@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

body {
  font-family: 'Lato', sans-serif;
}

h1,
h2,
h3,
label,
p,
span,
a {
  font-family: 'Host Grotesk', sans-serif;
}

.active {
  color: white !important;
}

.active-menuitem .layout-menuitem-root-text {
  color: white !important;
}

.layout {
  display: flex;
  height: 100;
}

.layout-menu-container {
  width: 270px;
  background-color: #000000;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 100vh;
}

.layout-menu {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.layout-menu .layout-root-menuitem>.layout-menuitem-root-text {
  font-size: 0.857rem;
  text-transform: uppercase;
  font-weight: 700;
  color: rgb(161, 161, 161);
  padding: 1rem 0;
}

.layout-menu ul a {
  display: flex;
  align-items: center;
  position: relative;
  outline: 0 none;
  color: var(--menuitem-text-color);
  cursor: pointer;
}

.layout-menu ul a:hover {
  background-color: rgb(46, 17, 124);
  color: white;
}

.layout-menu ul a .layout-menuitem-icon {
  margin-right: 8px;
  font-size: 1.2em;
  color: #93c04a;
}

.pi {
  font-family: primeicons;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.layout-menuitem-root-text {
  color: #93bf4b;
}

.layout-menu ul a:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.layout-menu ul a .layout-menuitem-icon {
  margin-right: 8px;
  font-size: 1.5em;
}

.layout-content-wrapper {
  flex: 1;
  padding: 20px;
  background-color: #f5f5f591;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pi {
  font-family: primeicons;
  display: inline-block;
  font-size: 1.25rem;
}

.content {
  flex: 1;
  background-color: #ffffff;
}

.layout-form-container {
  max-width: 900px;
  width: 100%;
}

.form-title {
  text-align: flex-start;
  margin-bottom: 60px;
  font-size: 40px;
}

.form-row {
  flex: 1;
  min-width: 250px;
}

.form-group {
  flex: 1;
}

.form-group:last-child {
  margin-right: 0;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  text-align: left;
}

input,
textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 15px;
}

.button-group {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.submit-button {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  background-color: #93bf4b;
  color: white;
  cursor: pointer;
  width: 20%;
  height: 40px;
}

.submit-button:hover {
  background-color: #000000;
}

.icon {
  margin-left: auto;
  font-size: 0.8em;
}

button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  background-color: #93bf4b;
  color: white;
  cursor: pointer;
  width: 100%;
}

button:hover {
  background-color: #93bf4b;
  color: #ffffff;
}

.file-upload-area {
  border: 2px dashed #ccc;
  border-radius: 4px;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100%;
  min-height: 150px;
}

.file-upload-area:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.file-upload-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 10%;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.file-upload-button {
  background: #000000;
  color: #77ff00;
  margin-right: 10px;
  width: 20%;
}

.file-name {
  color: #666;
  font-style: italic;
}

.file-description {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 3px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.compact-row {
  gap: 10px;
}

.form-group {
  flex: 1;
  min-width: 120px;
}

.compact-input {
  flex: 1;
  max-width: 30%;
}

label {
  margin-bottom: 5px;
  /* Spazio sotto l'etichetta */
  font-weight: bold;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
}

input[type="email"] {
  padding: 8px;
}

/* file  */
.file-upload-area {
  border: 2px dashed #ccc;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-upload-area:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.file-name {
  display: block;
  margin-top: 10px;
  font-weight: bold;
  color: #333;
}

.file-upload-area:empty::after {
  content: 'Trascina qui un file o fai clic per selezionare un file.';
  color: #aaa;
}

.file-upload-area p {
  text-align: center;
  font-style: italic;
  margin: 0;
}

.flex-container {
  display: flex;
  justify-content: space-between;
  gap: 50px;
}

.form-group {
  flex: 1;
  min-width: 200px;
}

.radio-group {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.radio-group label {
  font-weight: normal;
  margin-left: 10px;
}

.custom-dropdown {
  width: 100%;
  max-width: 100px;
}

@media (max-width: 768px) {
  .form-title {
    text-align: center !important;
    margin-top: 60px;
  }

  .layout-menu-container {
    display: none;
  }

  .form-row {
    flex-direction: column;
  }

  .form-group {
    max-width: 100%;
  }

  .button-group {
    display: flex;
    justify-content: center;
    flex-direction: row;
    margin-top: 20px;
  }

  .submit-button[data-v-5fb07102] {
    margin: 0 10px;
  }

  .submit-button {
    width: 80%;
    margin-bottom: 10px;
  }

  .toggle-sidebar-button {
    margin-bottom: 20px;
  }

  @media screen and (min-width: 992px) {
    .layout-container.layout-static .layout-content-wrapper {
      margin-left: 18rem;
      transition: margin-left var(--layout-section-transition-duration);
    }
  }
}
</style>
